import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../../../environments/environment';
import {Observable} from 'rxjs';
import {ResultadoBorradoConversacion} from '../../interfaces/resultado-borrado-conversacion';

@Injectable({
  providedIn: 'root'
})
export class BorrarConversacionService {


  private readonly conversacionUrl: string;

  constructor(private httpClient: HttpClient) {
    this.conversacionUrl = environment.apiUrl + '/shared/conversacion/';
  }

  public __invoke(conversacionId: string): Observable<ResultadoBorradoConversacion> {
    return this.httpClient.delete<ResultadoBorradoConversacion>(this.conversacionUrl + conversacionId);
  }
}
